import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { Router } from '@angular/router';
import { PermissionsService } from "../../../services/permissions/permissions.service";
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EmailSmsLangModalComponent } from 'src/app/components/email-sms-lang-modal/email-sms-lang-modal.component';
import { ParticipantLangModalComponent } from 'src/app/components/participant-lang-modal/participant-lang-modal.component';
import { QuestionnaireLimitModalComponent } from 'src/app/components/questionnaire-limit-modal/questionnaire-limit-modal.component';
import { LANG_OPTIONS } from 'src/app/lang.constants';
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { EmailSmsTemplateComponent } from '../../email-sms-template/email-sms-template.component';
import { EmailSmsPreviewModalComponent } from 'src/app/components/email-sms-preview-modal/email-sms-preview-modal.component';
import { EmailSmsPlaceholderModalComponent } from 'src/app/components/email-sms-placeholder-modal/email-sms-placeholder-modal.component';

@Component({
  selector: 'app-org-settings',
  templateUrl: './org-settings.component.pug',
  styleUrls: ['./org-settings.component.scss'],
  standalone: false
})
export class OrgSettingsComponent implements OnInit, OnChanges {

  @Input() org: any;
  org_detail: any;
  org_loaded = false;
  industry = '';
  domains = '';
  email_sms_langs = '';
  participant_langs = '';
  bsModalRef!: BsModalRef;
  managePermissions = {}
  errorMap = new Map([
    ["brand_name", new Map([["duplicate", $localize`An organisation with this name already exists, please contact support@xref.com.`]])],
    ["logo", new Map([["INFECTED_FILE_ERROR", $localize`Virus detected. Please upload a virus-free file and try again.`]])],
    ["domains", new Map([["social", $localize`Only business email domains can be used. Social domains (such as Gmail) will not be accepted.`]])],
  ]);
  previewModalRef: BsModalRef = new BsModalRef();
  placeholderModalRef: BsModalRef = new BsModalRef();
  messages = [];

  constructor(private organisationService: OrganisationService,
    private alertList: AlertBannerService,
    private modalService: BsModalService,
    private router: Router,
    public permissions: PermissionsService) {
  }

  ngOnInit(): void {
    if (this.org !== undefined) {
      this.loadOrg();
      const success = () => {
        if (this.permissions.hasUserOrgPermission('can_set_exit_settings')) {
          this.managePermissions['can_set_exit_settings'] = true;
        }

        this.org_loaded = true;
      }
      const error = () => {
        console.log(error);
        this.org_loaded = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }

      this.permissions.accManagementPermissionSubject.subscribe((hasDataLoaded) => {
        if (hasDataLoaded) {
          success();
        } else {
          error();
        }
      });

    }
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  loadOrg() {
    this.organisationService.getOrganisation().subscribe(data => {
      this.org_detail = data;
      this.organisationService.setOrganisationDetails(this.org_detail)
      this.formatOrgForVisualisation();
      this.org_loaded = true;
      }, error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
  }

  templateLanguage(type) {
    let displayLanguage = '';
    type.languages.forEach((val, index) => {
      if (index > 0) {
        displayLanguage += $localize` and ` + val;
      }
      else {
        displayLanguage += val;
      }
    })
    return displayLanguage;
  }

  showEmailSmsTemplate(type) {
    let initialState;
    let displayLanguage: any[]=[];
    this.org_detail['email_sms_langs'].forEach((val) => {
      displayLanguage.push(LANG_OPTIONS.get(val));
    })
    if(type == 'exit') {
      initialState = {
        'brand_name': this.org_detail['brand_name'],
        'templateType': type,
        'orgLanguages': this.templateLanguage({languages : displayLanguage})
      };
    }
    else {
      initialState = {
        'brand_name': this.org_detail['brand_name'],
        'selectedTemplate': type.selectedTemplate,
        'selectedTemplateValue': type.selectedTemplateValue,
        'templates': type.templates,
        'languages': type.languages,
        'managerTemplate': type.managerTemplate,
        'templateVariables': type.templateVariables,
        'templateType': 'exit',
        'orgLanguages': this.templateLanguage(type)
      };
    }
    // Workaround: Applying setTimeout to delay modal creation.
    // Issue: The backdrop wasn't displaying as expected, potentially due to an update in ngx-bootstrap.
    // This setTimeout introduces a brief delay to address rendering issues and ensure proper modal functionality.
    setTimeout(() => {
      this.bsModalRef = this.modalService.show(EmailSmsTemplateComponent, {
        class: 'modal-dialog-centered xxl-popup', initialState
      });
      this.bsModalRef.content.previewClick.subscribe(res => {
        this.bsModalRef.hide();
        this.showPreviewEmailSmsModal(res);
      });
      this.bsModalRef.content.viewPlaceholderClick.subscribe(res => {
        this.bsModalRef.hide();
        this.showPlaceholderModal(res);
      });
    }, 500);

  }

  showPreviewEmailSmsModal(type) {
    let initialState = type;
    // Workaround: Applying setTimeout to delay modal creation.
    // Issue: The backdrop wasn't displaying as expected, potentially due to an update in ngx-bootstrap.
    // This setTimeout introduces a brief delay to address rendering issues and ensure proper modal functionality.
    setTimeout(() => {
      this.previewModalRef = this.modalService.show(EmailSmsPreviewModalComponent, {
        class: 'modal-dialog-centered xxl-popup', initialState, ignoreBackdropClick: true
      });
      this.previewModalRef.content.backClick.subscribe(res => {
        this.showEmailSmsTemplate(initialState);
      })
      this.previewModalRef.content.saveClick.subscribe(res => {
        this.saveTemplate(initialState);
      })
    }, 500);
  }

  showPlaceholderModal(type) {
    let initialState = type;
    // Workaround: Applying setTimeout to delay modal creation.
    // Issue: The backdrop wasn't displaying as expected, potentially due to an update in ngx-bootstrap.
    // This setTimeout introduces a brief delay to address rendering issues and ensure proper modal functionality.
    setTimeout(() => {
      this.placeholderModalRef = this.modalService.show(EmailSmsPlaceholderModalComponent, {
        class: 'modal-dialog-centered xxl-popup', initialState, ignoreBackdropClick: true
      });
      this.placeholderModalRef.content.cancelClick.subscribe(res => {
        if (res) {
          this.showEmailSmsTemplate(initialState);
        }
      })
    }, 500);
  }

  setMessages(newMessages) {
    this.messages = this.messages.concat(newMessages);
  }

  saveTemplate(res) {
    this.messages = [];
    this.organisationService.updateOrganisationTemplate(res.selectedTemplate, res.templates).subscribe(response => {
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! Template was saved successfully.`,
        keepOnRouteChange: true
      }]);
      }, error => {
        console.log(error);
        for (const [key, value] of Object.entries(error.error['data']['errors'])) {
          let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
          let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          this.setMessages([{
            'type': 'danger',
            'message': message['message']
          }]);
        }
      })
    this.showEmailSmsTemplate('exit');
  }

  showEmailSmsLangModal() {
    let initialState = { 'email_sms_langs': _.cloneDeep(this.org_detail['email_sms_langs']),
    'model': 'exit' };
    this.bsModalRef = this.modalService.show(EmailSmsLangModalComponent, {
      class: 'modal-dialog-centered max-width-400', initialState
    });
    this.bsModalRef.content.event.subscribe(updates => {
      this.updateOrganisation(updates);
    });
  }



  showParticipantLangModal() {
    let initialState = {
      'participant_langs': _.cloneDeep(this.org_detail['participant_langs']),
      'model': 'exit'
    };
    this.bsModalRef = this.modalService.show(ParticipantLangModalComponent, {
      class: 'modal-dialog-centered max-width-552 max-height-591', initialState
    });
    this.bsModalRef.content.event.subscribe(updates => {
      this.updateOrganisation(updates);
    });
  }

  showQuestionnaireLimitModal() {
    let initialState = { 'questionnaire_limit': this.org_detail['questionnaire_limit'],
    'model': 'exit' };
    this.bsModalRef = this.modalService.show(QuestionnaireLimitModalComponent, {
      class: 'modal-dialog-centered max-width-352 max-height-257.34', initialState
    });
    this.bsModalRef.content.event.subscribe(updates => {
      this.updateOrganisation(updates);
    });
  }

  private formatOrgForVisualisation() {
    this.industry = this.org_detail['industry'] !== "" ? this.org_detail['industry'] : "Update";
    this.setDomain();
    this.setEmailSmsLang();
    this.setParticipantLang();
  }

  private setDomain() {
    this.domains = this.org_detail['domains'].join(', ');
    if (this.domains === "") {
      this.domains = $localize`Update`;
    }
  }

  private setEmailSmsLang() {
    // Set email sms lang label
    let email_sms_langs: any = [];
    for (let email_sms_lang of this.org_detail['email_sms_langs']) {
      email_sms_langs.push(LANG_OPTIONS.get(email_sms_lang));
    }
    this.email_sms_langs = email_sms_langs.join(', ');
    if (this.email_sms_langs === "") {
      this.email_sms_langs = $localize`Update`;
    }
  }

  private setParticipantLang() {
    // Set participant lang label
    let participant_langs: any = [];
    for (let participant_lang of this.org_detail['participant_langs']) {
      participant_langs.push(LANG_OPTIONS.get(participant_lang));
    }
    this.participant_langs = participant_langs.join(', ');
    if (this.participant_langs === "") {
      this.participant_langs = $localize`Update`;
    }
  }

  private updateOrganisation(updates) {
    this.organisationService.updateOrganisation(updates).subscribe(data => {
      if (data['saved']) {
        this.bsModalRef.content.markAsPristine();
        this.bsModalRef.hide();
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Changes have been saved.`,
          keepOnRouteChange: true
        }]);
        for (const [key, value] of Object.entries(updates)) {
          this.org_detail[key] = value;
          if (key === "brand_name") {
            this.org["brand_name"] = value;
          }
        }
        if (updates instanceof FormData) {
          this.org['logo'] = this.bsModalRef.content.avatar;
          this.org_detail['logo'] = this.org['logo'];
        }
        this.formatOrgForVisualisation();
      }
      }, error => {
        let messages: Array<any> = [];
        if (error.error['data'] !== null) {
          for (const [key, value] of Object.entries(error.error['data']['errors'])) {
            let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
            let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
            messages.push({
              'type': 'danger',
              'message': message
            });
          }
        } else {
          messages.push({
            'type': 'danger',
            'message': $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          });
        }
        this.bsModalRef.content.setMessages(messages);
      });
  }
}
